import { generateQr } from './generarteQr'

const downloadQr = async (body: any, tokens: any) => {
  const imageData = await generateQr(body, tokens)
  //TODO: check if donwload qr is in web
  return imageData
}

export { downloadQr }
